export enum FlagCategories {
  GENERAL = "General Configuration",
  REPORT = "Report Configuration",
  PROBLEMS = "Problems Configuration",
  COURSES = "Courses Management",
  USERS = "Users Management",
  GROUPS = "Companies Management"
}
